module.exports = __webpack_public_path__ + "img/serp-logo.c7dcc4f2.svg";